export const selectedReceiverIds: number[] = []

/**
 * 设置选中的 ID
 *
 * @param ids - 选中的 ID
 */
export const setSelectedReceiverIds = (ids: number[]) => {
  selectedReceiverIds.splice(0, selectedReceiverIds.length, ...ids)
}
